import NotificationCountBadge from './NotificationCountBadge';

export default NotificationCountBadge;
